import React from 'react'

const DL350 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Yokogawa</a>
                        <i class="fa fa-angle-right"></i>
                        <a href="/">Oscilloscopes</a>
                        <i class="fa fa-angle-right"></i>
                        <span>ScopeCorder </span>
                        <i class="fa fa-angle-right"></i>
                        <span>DL350 </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/dl350.jpg' width={400} style={{ marginTop: "80px", marginLeft: "90px" }}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>DL350:</h2>
                        <p class="mbot25">
                            The DL350 Portable ScopeCorder combines all the measurement and recording capabilities you
                            need when you are away from your office or lab - all in one compact instrument. Featuring a
                            resistive touch screen, the DL350 provides the flexibility you need when you need it. Whether
                            you are recording high-speed transients or long-term signals, using “quick and simple” setup or advanced features, the DL350 makes complete measurements completely portable.
                        </p>

                        <h4 style={{ textDecoration: "underline" }}>Portability</h4>
                        <p class="mbot25">
                            <ol>
                                <li>A4-sized compact chassis</li>
                                <li>Battery power for 3.5 hours</li>
                                <li>Resistive touch screen</li>
                                <li>Memory recorder mode for easy data logging setup</li>
                            </ol>
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Modularity</h4>
                        <p class="mbot25">
                            <ol>
                                <li>Compatible with 19 different input modules</li>
                                <li>Up to 8 channels analog inputs</li>
                                <li>Up to 100 MS/s sampling rate</li>
                                <li>Up to 16-bit analog resolution</li>
                            </ol>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default DL350
